import { render, staticRenderFns } from "./manuallyAdd.vue?vue&type=template&id=af5f08d8&scoped=true"
import script from "./manuallyAdd.vue?vue&type=script&lang=js"
export * from "./manuallyAdd.vue?vue&type=script&lang=js"
import style0 from "./manuallyAdd.vue?vue&type=style&index=0&id=af5f08d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5f08d8",
  null
  
)

export default component.exports